module.exports = __webpack_public_path__ + "imgs/cropped-Favicon-vdpResearch-Bordeaux-32x32.jpg";